import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import MEDPSetupSearchForm from './../MEDP/MEDPSetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'MEDPCode', numeric: false, disablePadding: true, label: 'MEDP Programme Code' },
    { id: 'MEDPTitle', numeric: false, disablePadding: true, label: 'MEDP Programme Title' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' },
    { id: 'OFOOccupation', numeric: false, disablePadding: true, label: 'OFO Occupation Code' },
    { id: 'Qualification', numeric: false, disablePadding: true, label: 'Qualification' }
];


const utils = new ViewUtils();

class MEDPSetupSearch extends Component {
    constructor(props) {
        super(props)

        let model = {
            MEDPCode: "",
            MEDPTitle: ""
        }

        this.searchParameters = !utils.isNull(this.props.programmeId) ?
            [
                { Name: "id", Value: this.props.programmeId },
                { Name: "MEDPCode", Value: "" },
                { Name: "MEDPTitle", Value: "" }
            ]
            :
            [
                { Name: "MEDPCode", Value: "" },
                { Name: "MEDPTitle", Value: "" },
            ]

        this.state = {
            model: model,
            selectedMEDPProgramme: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove MEDP', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/MEDPsetup/getsearch"}
                    entityViewPath='/MEDPsetup'
                    title='MEDP'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="MEDPTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/MEDPSetup/removeMEDP"} useDeletePost={true}
                    promptTitle={"Remove MEDP Programme"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the MEDP programme is a permanent action and the MEDP programme will not be available going forward. Are you sure you want to remove this MEDP programme?"}
                >
                    <MEDPSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(MEDPSetupSearch));

